import React, { useContext } from 'react';
import PrintIcon from '@material-ui/icons/Print';
import { TableContext, TableToolbarButton } from '@eas/common-web';

export function ExportTableToolbarButton() {
  const { openExportDialog } = useContext(TableContext);

  return (
    <TableToolbarButton label={<PrintIcon />} onClick={openExportDialog} />
  );
}
